import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class HideStoryMedia extends BaseOption {
  static userInterfaceComponent = {
    label: "Hide Primary Story Media",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ],
    },
  };

  static defaultValue = false;
}

